import { PerformanceViewModel, IProductionModels } from './classes';

export function addPerformance(performance: PerformanceViewModel) {
    return {
        type: ActionTypes.AddPerformance,
        value: performance
    }
}

export function initializePerformances(production: IProductionModels) {
    return {
        type: ActionTypes.LoadPerformance,
        value: production
    }
}


export class ActionTypes {
    static get AddPerformance() {
        return "AddPerformance";
    }

    static get LoadPerformance() {
        return "LoadPerformance";
    }
}